import classNames from 'classnames';

import styles from './FooterLayout.module.css';

import { GridItem, type GridItemProps } from '../Grid';

/** The column component for the footer layout */
export function FooterColumn({ children, ...gridItemProps }: GridItemProps) {
  return (
    <GridItem
      flexDirection="column"
      className={classNames(styles.column, gridItemProps.className)}
      {...gridItemProps}
    >
      {children}
    </GridItem>
  );
}
